import normal400 from "./Roboto-400-normal.woff2";
import normal700 from "./Roboto-700-normal.woff2";
import italic400 from "./Roboto-400-italic.woff2";
import italic700 from "./Roboto-700-italic.woff2";
import { Global } from "@emotion/react";

export const Roboto = () => {
    return (
        <Global
            styles={[
                {
                    "@font-face": {
                        fontFamily: "Roboto",
                        fontStyle: "normal",
                        fontWeight: 400,
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        src: `url('${normal400}') format('woff2')`
                    }
                },
                {
                    "@font-face": {
                        fontFamily: "Roboto",
                        fontStyle: "normal",
                        fontWeight: 700,
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        src: `url('${normal700}') format('woff2')`
                    }
                },
                {
                    "@font-face": {
                        fontFamily: "Roboto",
                        fontStyle: "italic",
                        fontWeight: 400,
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        src: `url('${italic400}') format('woff2')`
                    }
                },
                {
                    "@font-face": {
                        fontFamily: "Roboto",
                        fontStyle: "italic",
                        fontWeight: 700,
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        src: `url('${italic700}') format('woff2')`
                    }
                }
            ]}
        />
    );
};
